import React from 'react'
import Container from '@material-ui/core/Container';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import galeria1 from '../../assets/galerials1.jpg';
import galeria2 from '../../assets/galerials2.jpg';
import galeria3 from '../../assets/galerials3.jpg';
import galeria4 from '../../assets/galerials4.jpg';
import galeria5 from '../../assets/galerials5.jpg';
import galeria6 from '../../assets/galerials6.jpg';
import galeria7 from '../../assets/galerials7.jpg';
import galeria8 from '../../assets/galerials8.jpg';
import galeria9 from '../../assets/galerials9.jpg';



const Section3 = () => {
  return (
    <div id='proyecto' className='section noPadBot'>
        <Container className='relative flex flexCol relative'>
         
              <Swiper
                spaceBetween={30}
                grabCursor={true}
                pagination={{
                  clickable: true,
                }}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
                modules={[Autoplay, Pagination]}
                className="galeriaSwiper shadow"
              >
                <SwiperSlide>
                  <img src={galeria1} alt="Glaeria 1" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria2} alt="Glaeria 2" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria3} alt="Glaeria 3" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria4} alt="Glaeria 4" />
                </SwiperSlide>
               
                <SwiperSlide>
                  <img src={galeria5} alt="Glaeria 5" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria6} alt="Glaeria 6" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria7} alt="Glaeria 7" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria8} alt="Glaeria 8" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src={galeria9} alt="Glaeria 9" />
                </SwiperSlide>
              </Swiper>
              <div className="floatTitle shadow">
                <h2>Proyecto</h2>
                <p>Vivienda familiar desarrollada en planta baja de 93.5 m2 cubiertos, 12 m2 semicubiertos, 48 m2 de terraza con parrilla y piscina, área de estacionamiento y jardines.</p>
              </div>
        </Container>
    </div>
  )
}

export default Section3